import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'

Vue.component('NewsSlider', {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      options: {
        direction: 'vertical',
        slidesPerView: 2,
        centeredSlides: true,
        loop: true,
        spaceBetween: 4,
        slidesOffsetBefore: 185,
        pagination: {
          el: '.news-slider-pagination',
          type: 'fraction', //"bullets", "fraction", "progressbar" or "custom"
          formatFractionCurrent: function (number) {
            return '0' + number;
          },
          formatFractionTotal: function (number) {
            return '0' + number;
          },
          renderFraction: function (currentClass, totalClass) {
            return `
              <p class="xxxsmall">
                <span class="text-orange ' + ${currentClass} + '">01</span>
                <span>/</span>
                <span class="' + ${totalClass} + '">08</span>
              </p>
            `;
          }
        },
        navigation: {
          nextEl: '.btn-slider-next',
          prevEl: '.btn-slider-prev',
        },
      }
    }
  },
})


// WEBPACK FOOTER //
// ./src/js/news-inner.js